import TecnicoEnderecoService from "@/services/TecnicoEnderecoService";

export const tecnicoEndereco = {
  namespaced: true,
  state: {
    tecnicoEndereco: {},
  },
  actions: {
    getTecnicoEndereco({ commit }, payload) {
      return TecnicoEnderecoService.GetTecnicoEndereco(payload).then(
        (tecnicoEndereco) => {
          return Promise.resolve(tecnicoEndereco);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postTecnicoEndereco({ commit }, payload) {
      return TecnicoEnderecoService.PostTecnicoEndereco(payload).then(
        (tecnicoEndereco) => {
          return Promise.resolve(tecnicoEndereco);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putTecnicoEndereco({ commit }, payload) {
      return TecnicoEnderecoService.PutTecnicoEndereco(payload).then(
        (tecnicoEndereco) => {
          return Promise.resolve(tecnicoEndereco);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteTecnicoEndereco({ commit }, payload) {
      return TecnicoEnderecoService.DeleteTecnicoEndereco(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getTecnicoEnderecoOData({ commit }, payload) {
      return TecnicoEnderecoService.GetTecnicoEnderecoOData(payload).then(
        (tecnicoEndereco) => {
          return Promise.resolve(tecnicoEndereco);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default tecnicoEndereco;
